export const formatSalary = (value) => value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') ?? 0;